import { RestApi } from '../../common/services';
import { TSFixMe } from '../../frontend-libs/evlapp-types';
import { store } from '../../common/store/store';

/**
 * Get building logs with pagination and optional filters
 * @param {number} limit - Number of logs to fetch (default: 100)
 * @param {number} offset - Number of logs to skip (default: 0)
 * @param {string[]} units - Array of unit IDs to filter by (optional)
 * @param {string[]} profiles - Array of profile IDs to filter by (optional)
 * @return {Promise<TSFixMe[]>} array with building logs
 */
export const getBuildingLogs = async (
  limit = 100, 
  offset = 0, 
  units?: string[], 
  profiles?: string[]
): Promise<TSFixMe[]> => {
  const buildingId = store.getState().security.ui.buildingId;
  
  const params = new URLSearchParams();
  params.append('limit', limit.toString());
  params.append('offset', offset.toString());
  
  // Add unit filters
  if (units && units.length > 0) {
    units.forEach(unitId => params.append('units[]', unitId));
  }
  
  // Add profile filters
  if (profiles && profiles.length > 0) {
    profiles.forEach(profileId => params.append('profiles[]', profileId));
  }
  
  return await RestApi.get<never, TSFixMe[]>(
    `/building/${buildingId}/log?${params.toString()}`
  );
};

/**
 * Get building registry info
 * @return {Promise<TSFixMe>} building registry info
 */
export const getRegistryBuildingInfo = async (): Promise<TSFixMe> => {
  const buildingId = store.getState().security.ui.buildingId;
  return await RestApi.get<never, TSFixMe>(
    `/building/${buildingId}/log-building-info`
  );
};

export interface MonitoringNotificationSetting {
  changeEnabled: boolean;
  reportEnabled: boolean;
}

/** Per-admin nastavení e-mailových notifikací monitoringu (okamžitá změna / měsíční report). */
export const getMonitoringNotificationSetting = async (): Promise<MonitoringNotificationSetting> => {
  const buildingId = store.getState().security.ui.buildingId;
  return await RestApi.get<never, MonitoringNotificationSetting>(
    `/building/${buildingId}/monitoring-notification-setting`
  );
};

export const setMonitoringNotificationSetting = async (
  type: 'change' | 'report',
  enabled: boolean
): Promise<MonitoringNotificationSetting> => {
  const buildingId = store.getState().security.ui.buildingId;
  return await RestApi.post<{ type: string; enabled: boolean }, MonitoringNotificationSetting>(
    `/building/${buildingId}/monitoring-notification-setting`,
    { type, enabled }
  );
};
